<template>
  <b-notification :has-icon="true" :icon="'unlink'" :closable="false">
    <strong>
      {{ $t('compCarbonFormsSurveyUnvalidLink.unvalid-title') }}
    </strong>
    <br />
    {{ $t('compCarbonFormsSurveyUnvalidLink.unvalid-1') }}
    <br />
    {{ $t('compCarbonFormsSurveyUnvalidLink.unvalid-2') }}
  </b-notification>
</template>

<script>
export default {
  name: 'UnvalidLink'
}
</script>
